import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    console.log('Auth useEffect triggered - token:', token);
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const stored = localStorage.getItem('admin');
      if (stored) {
        try {
          setAdmin(JSON.parse(stored));
          console.log('Admin set from localStorage');
        } catch { }
      }
    }
    setLoading(false);
  }, [token]);

  const login = async (email, password) => {
    console.log('Login function called with email:', email);
    const response = await axios.post(`${API_URL}/login`, { email, password });
    console.log('Login API response:', response.data);
    const { token: accessToken, admin: adminData } = response.data;

    console.log('Storing token and admin data...');
    localStorage.setItem('token', accessToken);
    localStorage.setItem('admin', JSON.stringify(adminData));
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    setToken(accessToken);
    setAdmin(adminData);
    console.log('Token and admin set in state');

    return adminData;
  };

  const register = async (name, email, password) => {
    throw new Error('Registration is disabled. Contact admin for access.');
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setAdmin(null);
  };

  const updateProfile = async (data) => {
    const updated = { ...admin, ...data };
    setAdmin(updated);
    localStorage.setItem('admin', JSON.stringify(updated));
    return updated;
  };

  const changePassword = async (currentPassword, newPassword) => {
    throw new Error('Password change not available. Contact admin.');
  };

  const value = {
    admin,
    loading,
    isAuthenticated: !!admin,
    login,
    register,
    logout,
    updateProfile,
    changePassword
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
